import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { z } from "zod";

export const usePagoParams = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const id_pago_raw = searchParams.get("id_pago");
    const id_schema = z.coerce.number().int().positive();
    const array_schema = z.array(id_schema).nonempty("Se requiere al menos un ID válido");

    if (id_pago_raw) {
      const result = id_schema.safeParse(id_pago_raw);
      if (!result.success) {
        console.warn("ID de cobro inválido:", result.error.issues);
        return { id_pago: null, ids_comprobantes: [], hasError: true };
      }
      return { id_pago: result.data, ids_comprobantes: [], hasError: false };
    }

    const ids_raw = searchParams.get("ids_comprobantes");
    const ids_array = ids_raw?.split(",") ?? [];
    const result = array_schema.safeParse(ids_array);

    if (!result.success) {
      console.warn("IDs de comprobantes inválidos:", result.error.issues);
      return { id_pago: null, ids_comprobantes: [], hasError: true };
    }

    return { id_pago: null, ids_comprobantes: result.data, hasError: false };
  }, [searchParams]);
};
